import Step from "./Step";

class Step7 extends Step {
    constructor() {
        super(8, 'scheduler', $(`[data-register-step="scheduler"]`));

        // UI Elements - Scheduler View
        this.calendarContainer = $('#calendar_container');
        this.timeSlotsEmpty = $('#time_slots_empty');
        this.timeSlotsContainer = $('#time_slots_container');
        this.timeSlotsGrid = $('#time_slots_grid');
        this.selectedDateDisplay = $('#selected_date_display');
        this.continueToConfirmationBtn = $('#continue_to_confirmation_btn');
        this.backToStep6Btn = $('#back_to_step6');
        this.schedulerButtons = $('#scheduler_buttons');




        // View state
        this.currentView = 'scheduler'; // 'scheduler', 'confirmation', or 'success'

        // Demo scheduling state
        this.availableSlots = [];
        this.slotsByDate = {};
        this.selectedDate = null;
        this.selectedTimeSlot = null;
        this.existingDemo = null;

        // Calendar state
        this.currentDate = new Date();

        // Editing state
        this.isEditing = false;
        this.editingDemoData = null;
    }

    init() {
        console.log('Step7 init: Demo scheduler');

        // Check if we're editing an existing demo
        this.checkEditingMode();

        this.attachEventHandlers();
        this.loadDemoSlots();
    }

    checkEditingMode() {
        console.log('Step7: Checking if editing mode is active');

        if (window.editingDemo) {
            console.log('Found editing demo data:', window.editingDemo);
            this.isEditing = true;
            this.editingDemoData = window.editingDemo;
            this.existingDemo = {
                id: window.editingDemo.id,
                scheduled_at: window.editingDemo.scheduled_at,
                notes: window.editingDemo.notes
            };

            // Clear the window variable to avoid conflicts
            delete window.editingDemo;

            console.log('Scheduler set to editing mode for demo:', this.existingDemo.id);
        } else {
            console.log('No editing demo data found - scheduler in creation mode');
            this.isEditing = false;
            this.editingDemoData = null;
        }
    }

    attachEventHandlers() {
        console.log('Step7: Attaching event handlers');

        // Scheduler View Buttons
        this.backToStep6Btn.off('click').on('click', (e) => {
            e.preventDefault();
            console.log('Back to congrats clicked');
            this.goToStep('congrats');
        });

        this.continueToConfirmationBtn.off('click').on('click', (e) => {
            e.preventDefault();
            console.log('Continue to confirmation clicked');
            this.proceedToConfirmation();
        });


    }

    async checkExistingDemo() {
        try {
            const response = await API.get('/demo/existing');

            if (response.status === 'success' && response.demo) {
                console.log('User has existing demo:', response.demo);

                // Show existing demo alert
                const formattedDate = new Date(response.demo.scheduled_at).toLocaleDateString('nl-NL', {
                    weekday: 'long',
                    day: 'numeric',
                    month: 'long',
                    year: 'numeric',
                    hour: '2-digit',
                    minute: '2-digit'
                });

                $('#existing_demo_datetime').text(formattedDate);
                $('#existing_demo_alert').removeClass('d-none');

                this.existingDemo = response.demo;
            } else {
                console.log('No existing demo found');
                $('#existing_demo_alert').addClass('d-none');
                this.existingDemo = null;
            }
        } catch (error) {
            console.error('Error checking existing demo:', error);
            this.existingDemo = null;
        }
    }

    async loadDemoSlots() {
        console.log('Loading demo slots...');

        // First check if user has existing demo
        await this.checkExistingDemo();

        try {
            const response = await API.get('/demo/slots');

            // Handle different response formats
            let slots = [];
            if (Array.isArray(response)) {
                // Direct array response
                slots = response;
            } else if (response.status === 'success' && response.slots) {
                // Wrapped response with status
                slots = response.slots;
            } else if (response.data && Array.isArray(response.data)) {
                // Response with data wrapper
                slots = response.data;
            } else {
                console.error('Unexpected response format:', response);
                return;
            }

            if (slots.length > 0) {
                this.availableSlots = slots;

                // Group slots by date for easier lookup
                this.slotsByDate = {};
                this.availableSlots.forEach(slot => {
                    if (!this.slotsByDate[slot.date]) {
                        this.slotsByDate[slot.date] = [];
                    }
                    this.slotsByDate[slot.date].push(slot);
                });

                // Rebuild calendar with available slots
                this.buildCalendar();

                // If in editing mode, pre-select the existing demo's date and time
                if (this.isEditing && this.existingDemo) {
                    this.preSelectExistingDemo();
                }
            } else {
                this.availableSlots = [];
                this.slotsByDate = {};
                this.buildCalendar();

                // If in editing mode, still try to pre-select even without available slots
                if (this.isEditing && this.existingDemo) {
                    this.preSelectExistingDemo();
                }
            }
        } catch (error) {
            console.error('Error loading demo slots:', error);

            // Initialize empty state on error
            this.availableSlots = [];
            this.slotsByDate = {};
            this.buildCalendar();

            // If in editing mode, still try to pre-select even on error
            if (this.isEditing && this.existingDemo) {
                this.preSelectExistingDemo();
            }
        }
    }

    preSelectExistingDemo() {
        console.log('Step7: Pre-selecting existing demo data');

        if (!this.existingDemo || !this.existingDemo.scheduled_at) {
            console.warn('No existing demo data to pre-select');
            return;
        }

        const demoDate = new Date(this.existingDemo.scheduled_at);
        // Format date string without timezone conversion to avoid day shifts
        const demoDateString = `${demoDate.getFullYear()}-${String(demoDate.getMonth() + 1).padStart(2, '0')}-${String(demoDate.getDate()).padStart(2, '0')}`;

        console.log('Pre-selecting demo date:', demoDateString);
        console.log('Pre-selecting demo time:', demoDate.toISOString());

        // Set the current view to the month containing the demo
        this.currentDate = new Date(demoDate.getFullYear(), demoDate.getMonth(), 1);
        this.buildCalendar();

        // Wait for calendar to be built, then select the date
        setTimeout(() => {
            // Find and click the date element
            const dateElement = $(`[data-date="${demoDateString}"]`);
            if (dateElement.length > 0) {
                console.log('Found demo date element, selecting it');

                // Add selected class and set selected date
                $('.calendar-day').removeClass('selected');
                dateElement.addClass('selected');
                this.selectedDate = demoDateString;

                // Load time slots for the date
                this.loadTimeSlotsForDate(demoDateString);

                // Wait for time slots to load, then select the time
                setTimeout(() => {
                    const targetTime = demoDate.toLocaleTimeString('nl-NL', {
                        hour: '2-digit',
                        minute: '2-digit'
                    });
                    console.log('Looking for time slot:', targetTime);

                    // Find time slot that matches the demo time
                    const timeSlotElement = $(`.time-slot[data-time="${targetTime}"]`);
                    if (timeSlotElement.length > 0) {
                        console.log('Found demo time slot, selecting it');

                        // Select the time slot
                        $('.time-slot').removeClass('selected');
                        timeSlotElement.addClass('selected');

                        this.selectedTimeSlot = {
                            datetime: this.existingDemo.scheduled_at,
                            time: targetTime,
                            date: demoDateString
                        };

                        // Enable continue button
                        this.continueToConfirmationBtn.prop('disabled', false);

                        console.log('Demo pre-selected successfully');
                    } else {
                        console.warn('Could not find matching time slot for:', targetTime);
                    }
                }, 500);

            } else {
                console.warn('Could not find date element for:', demoDateString);
            }
        }, 500);

        // Pre-populate notes if they exist
        if (this.existingDemo.notes) {
            // This will be used when showing confirmation view
            this.existingNotes = this.existingDemo.notes;
        }
    }

    buildCalendar() {
        const year = this.currentDate.getFullYear();
        const month = this.currentDate.getMonth();

        // Create calendar header
        const monthNames = [
            'januari', 'februari', 'maart', 'april', 'mei', 'juni',
            'juli', 'augustus', 'september', 'oktober', 'november', 'december'
        ];

        const dayNames = ['zo', 'ma', 'di', 'wo', 'do', 'vr', 'za'];

        let calendarHTML = `
            <div class="calendar-header d-flex justify-content-between align-items-center mb-4">
                <button type="button" class="btn btn-sm btn-light-primary" id="prev_month">
                    <i class="fas fa-chevron-left"></i>
                </button>
                <h5 class="mb-0 fw-bold text-primary">${monthNames[month]} ${year}</h5>
                <button type="button" class="btn btn-sm btn-light-primary" id="next_month">
                    <i class="fas fa-chevron-right"></i>
                </button>
            </div>
            <table>
                <thead>
                    <tr>
        `;

        dayNames.forEach(day => {
            calendarHTML += `<th>${day}</th>`;
        });

        calendarHTML += `</tr></thead><tbody>`;

        // Get first day of month and number of days
        const firstDay = new Date(year, month, 1).getDay();
        const daysInMonth = new Date(year, month + 1, 0).getDate();
        const today = new Date();

        let date = 1;

        // Generate calendar rows
        for (let week = 0; week < 6; week++) {
            calendarHTML += '<tr>';

            for (let dayOfWeek = 0; dayOfWeek < 7; dayOfWeek++) {
                if (week === 0 && dayOfWeek < firstDay) {
                    // Empty cells before month starts
                    calendarHTML += '<td><div class="calendar-day other-month"></div></td>';
                } else if (date > daysInMonth) {
                    // Empty cells after month ends
                    calendarHTML += '<td><div class="calendar-day other-month"></div></td>';
                } else {
                    const currentDate = new Date(year, month, date);
                    // Format date string without timezone conversion to avoid day shifts
                    const dateString = `${year}-${String(month + 1).padStart(2, '0')}-${String(date).padStart(2, '0')}`;

                    // Check if date has available slots
                    const hasSlots = this.slotsByDate &&
                        this.slotsByDate[dateString] &&
                        this.slotsByDate[dateString].length > 0;

                    // Compare dates only (not time) to avoid timezone issues
                    const currentDateOnly = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate());
                    const todayOnly = new Date(today.getFullYear(), today.getMonth(), today.getDate());
                    const isPast = currentDateOnly < todayOnly;
                    const isAvailable = !isPast && hasSlots;

                    let dayClass = 'calendar-day';
                    if (isPast) {
                        dayClass += ' disabled';
                    } else if (isAvailable) {
                        dayClass += ' available';
                    }

                    calendarHTML += `
                        <td>
                            <div class="${dayClass}" data-date="${dateString}" data-day="${date}">
                                ${date}
                            </div>
                        </td>
                    `;
                    date++;
                }
            }

            calendarHTML += '</tr>';
            if (date > daysInMonth) break;
        }

        calendarHTML += '</tbody></table>';

        this.calendarContainer.html(calendarHTML);

        // Attach calendar event handlers
        this.attachCalendarHandlers();
    }

    attachCalendarHandlers() {
        // Month navigation
        $('#prev_month').off('click').on('click', (e) => {
            e.preventDefault();
            this.currentDate.setMonth(this.currentDate.getMonth() - 1);
            this.buildCalendar();
        });

        $('#next_month').off('click').on('click', (e) => {
            e.preventDefault();
            this.currentDate.setMonth(this.currentDate.getMonth() + 1);
            this.buildCalendar();
        });

        // Date selection using event delegation
        this.calendarContainer.off('click', '.calendar-day.available').on('click', '.calendar-day.available', (e) => {
            const dateElement = $(e.currentTarget);
            const selectedDate = dateElement.data('date');

            console.log('Calendar date clicked:', selectedDate);

            // Update selected state
            $('.calendar-day').removeClass('selected');
            dateElement.addClass('selected');

            this.selectedDate = selectedDate;
            this.selectedTimeSlot = null;

            // Hide empty state immediately by removing flex classes and hiding
            this.timeSlotsEmpty.removeClass('d-flex flex-column').hide();

            // Load time slots for selected date
            this.loadTimeSlotsForDate(selectedDate);
        });
    }

    loadTimeSlotsForDate(date) {
        console.log('Loading time slots for date:', date);
        console.log('Available slots:', this.slotsByDate[date] || []);

        // Ensure empty state is hidden by removing flex classes and hiding
        this.timeSlotsEmpty.removeClass('d-flex flex-column').hide();

        const slots = this.slotsByDate[date] || [];

        if (slots.length === 0) {
            console.log('No slots available for this date');
            // Hide time slots container and show a different message
            this.timeSlotsContainer.hide();
            this.timeSlotsGrid.html('<div class="text-center py-4"><p class="text-muted">Geen beschikbare tijden voor deze datum</p></div>');
            this.timeSlotsContainer.show();
            return;
        }

        // Format date for display
        const dateObj = new Date(date);
        const formattedDate = dateObj.toLocaleDateString('nl-NL', {
            weekday: 'long',
            day: 'numeric',
            month: 'long'
        });
        this.selectedDateDisplay.text(formattedDate);

        // Calculate and display daily limit info
        let timeSlotsHTML = '';
        slots.forEach(slot => {
            const time = new Date(slot.datetime).toLocaleTimeString('nl-NL', {
                hour: '2-digit',
                minute: '2-digit'
            });

            timeSlotsHTML += `
                <div class="time-slot" data-datetime="${slot.datetime}" data-time="${time}" data-date="${date}">
                    <div class="fw-bold">${time}</div>
                    <div class="fs-7 text-muted">${slot.available_spots} plek${slot.available_spots !== 1 ? 'ken' : ''} beschikbaar</div>
                </div>
            `;
        });

        this.timeSlotsGrid.html(timeSlotsHTML);

        // Show the time slots container
        this.timeSlotsContainer.show();

        console.log('Time slots container shown');

        // Attach time slot handlers using event delegation
        this.timeSlotsGrid.off('click', '.time-slot').on('click', '.time-slot', (e) => {
            const timeSlot = $(e.currentTarget);
            const datetime = timeSlot.data('datetime');
            const time = timeSlot.data('time');
            const date = timeSlot.data('date');

            // Update selected state
            $('.time-slot').removeClass('selected');
            timeSlot.addClass('selected');

            this.selectedTimeSlot = {
                datetime: datetime,
                time: time,
                date: date
            };

            // Enable the continue button
            this.continueToConfirmationBtn.prop('disabled', false);

            console.log('Time slot selected:', this.selectedTimeSlot);
        });
    }

    proceedToConfirmation() {
        if (!this.selectedDate || !this.selectedTimeSlot) {
            message.error('Selecteer eerst een datum en tijdstip.');
            return;
        }

        console.log('Proceeding to confirmation step');

        // Save data to global register object for Step 8 to use
        if (window.register) {
            window.register.demoData = {
                date: this.selectedDate,
                timeSlot: this.selectedTimeSlot,
                existingDemo: this.existingDemo
            };
            this.goToStep('confirm_demo');
        } else {
            console.error('window.register not found');
            // Fallback: trigger event
            $(document).trigger('stepper:goto', 'confirm_demo');
        }
    }

    async scheduleDemo() {
        if (!this.selectedDate || !this.selectedTimeSlot) {
            console.error('No date/time selected');
            return;
        }

        // Get notes from the textarea
        const notes = this.demoNotes.val() || '';

        // Show loading state
        this.confirmDemoBtn.attr('data-kt-indicator', 'on');

        try {
            let response;
            let requestData = {
                scheduled_at: this.selectedTimeSlot.datetime,
                notes: notes
            };

            // Always use POST to schedule/update demo
            // Include demo_id if updating existing demo
            if (this.isEditing && this.existingDemo) {
                console.log('Updating existing demo:', this.existingDemo.id);
                requestData.demo_id = this.existingDemo.id;
            } else if (this.existingDemo && !this.isEditing) {
                // This handles the old checkExistingDemo flow
                console.log('Updating existing demo (legacy):', this.existingDemo.id);
                requestData.demo_id = this.existingDemo.id;
            } else {
                console.log('Creating new demo');
            }

            response = await API.post('/demo/schedule', requestData);

            if (response.status === 'success') {
                console.log('Demo scheduled successfully');

                // Show success notification
                const successMessage = this.isEditing ? 'Demo is succesvol bijgewerkt!' : 'Demo is succesvol ingepland!';
                message.success(successMessage);

                // Wait a moment to show the notification, then go back to Step 5
                setTimeout(() => {
                    if (window.register) {
                        window.register.goNext('congrats');
                    }
                }, 800);

            } else {
                console.error('Error scheduling demo:', response.message);
                message.error(response.message || 'Er is een fout opgetreden bij het plannen van de demo.');
            }
        } catch (error) {
            console.error('Error scheduling demo:', error);

            // Show error notification
            let errorMessage = 'Er is een fout opgetreden bij het plannen van de demo.';
            if (error.responseJSON && error.responseJSON.message) {
                errorMessage = error.responseJSON.message;
            } else if (error.message) {
                errorMessage = error.message;
            }

            message.error(errorMessage);
        } finally {
            this.confirmDemoBtn.attr('data-kt-indicator', 'off');
        }
    }

    goToStep(stepNumber) {
        console.log('Step7.goToStep called with stepNumber:', stepNumber);

        // Use the register's standard navigation
        if (window.register) {
            console.log('Calling goNext(' + stepNumber + ')');
            window.register.goNext(stepNumber);
        } else {
            console.error('window.register not available');
        }
    }

}

export default Step7;
